import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'

import pl from './trans/pl'
import en from './trans/en'

Vue.use(VueI18n)

Vue.config.productionTip = false

Vue.config.errorHandler = window.handleError

import VueSimpleSVG from 'vue-simple-svg'

Vue.use(VueSimpleSVG)

import PrettyCheckbox from 'pretty-checkbox-vue'

Vue.use(PrettyCheckbox)
import 'pretty-checkbox/dist/pretty-checkbox.min.css'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue: Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.01,
  })
}

const i18n = new VueI18n({
  messages: {
    en,
    pl,
  },
  locale: navigator.language.slice(0, 2),
})

new Vue({
  i18n,
  render: (h) => h(App),
}).$mount('#app')
